import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Snap Windows';
const SITE_URL = 'https://snap-windows.com';
const DEFAULT_DESCRIPTION =
  'Impact windows and doors in South Florida. Upload photos and get real Good/Better/Premium pricing — no in-home sales appointment required.';
const DEFAULT_IMAGE =
  'https://customer-assets.emergentagent.com/job_impact-quote-hub/artifacts/p1dw6cbv_WhatsApp%20Image%202026-04-17%20at%2012.19.27%20PM.jpeg';

/**
 * Reusable per-page SEO/meta component.
 *
 * Sets a unique <title> and <meta name="description"> (plus canonical +
 * Open Graph / Twitter tags) for every route. Rendered with react-helmet-async
 * so it works safely with React 19 + our build-time prerender step
 * (scripts/prerender.js), which captures the final document <head> for
 * each route into a static HTML file — giving crawlers real per-page
 * titles/descriptions without needing to execute JavaScript.
 *
 * Purely a <head> side-effect component — renders nothing visible, so it
 * never affects layout or design.
 */
export const SEO = ({ title, description, path, image, noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Impact Windows & Doors South Florida`;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonical = path ? `${SITE_URL}${path}` : undefined;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
